import { HTMLAttributes } from "react";

export default (props: HTMLAttributes<SVGElement>) => (<svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 19V16H5V14H10V19H8ZM14 19V14H19V16H16V19H14ZM5 10V8H8V5H10V10H5ZM14 10V5H16V8H19V10H14Z" fill="black"/>
</svg>)
